export default __webpack_public_path__ + "static/media/Home_Header_Cut-Out.807327f9.svg";